export const pipeline = {
  en: {
    pipeline: {
      title: "Pipeline",
      subtitle: "Track your service requests, proposals, and approvals",
      newRequest: "New Request",
      noItems: "No items in this stage",
      // Card actions
      editDraft: "Continue",
      viewRequest: "View",
      viewProposal: "View Proposal",
      approve: "Approve",
      reject: "Reject",
      addNotes: "Add notes (optional)...",
      processing: "Processing...",
      // Card labels
      progress: "complete",
      expires: "Expires",
      views: "views",
      requestedBy: "Requested by",
      due: "Due",
      overdue: "(overdue)",
      clientApproval: "Client Approval",
      teamApproval: "Team Approval",
      // Counts
      items: "items",
      item: "item",
    },
  },
  es: {
    pipeline: {
      title: "Pipeline",
      subtitle: "Seguimiento de solicitudes, propuestas y aprobaciones",
      newRequest: "Nueva Solicitud",
      noItems: "Sin elementos en esta etapa",
      editDraft: "Continuar",
      viewRequest: "Ver",
      viewProposal: "Ver Propuesta",
      approve: "Aprobar",
      reject: "Rechazar",
      addNotes: "Agregar notas (opcional)...",
      processing: "Procesando...",
      progress: "completado",
      expires: "Expira",
      views: "vistas",
      requestedBy: "Solicitado por",
      due: "Fecha límite",
      overdue: "(vencido)",
      clientApproval: "Aprobación de Cliente",
      teamApproval: "Aprobación de Equipo",
      items: "elementos",
      item: "elemento",
    },
  },
};
